import { useLayoutEffect } from 'react'
import useResizeObserver from '@react-hook/resize-observer'
import { useSetScrollbarVisibility } from '../../store/scrollContainer/hooks/useSetScrollbarVisibility'
import { getScrollContainerElement } from '../../lib/dom'

const isContentOverflowing = (e: HTMLDivElement) => e.scrollHeight > e.clientHeight

export const useUpdateScrollbarPresenceFlag = () => {
  const scrollzoneEl = getScrollContainerElement()

  const setVisibility = useSetScrollbarVisibility()

  const updateVisibility = (el: HTMLDivElement) => {
    setVisibility(isContentOverflowing(el))
  }

  // first render
  useLayoutEffect(() => {
    if (!scrollzoneEl) return
    updateVisibility(scrollzoneEl)
  }, [scrollzoneEl]) // eslint-disable-line

  useResizeObserver(scrollzoneEl, entry => updateVisibility(entry.target as HTMLDivElement))
}
